import { render, staticRenderFns } from "./ContentIcon.vue?vue&type=template&id=3b82a980&scoped=true&"
import script from "./ContentIcon.vue?vue&type=script&lang=js&"
export * from "./ContentIcon.vue?vue&type=script&lang=js&"
import style0 from "./ContentIcon.vue?vue&type=style&index=0&id=3b82a980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b82a980",
  null
  
)

component.options.__file = "ContentIcon.vue"
export default component.exports